(() => {
  'use strict';

  const bodySelector = 'body.brand-siecle.template-product:not(.template-suffix-siecle-watch)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initializeGallery(gallery) {
    if (!gallery || gallery.dataset.siecleClothingInitialized === 'true') return;
    const grid = gallery.querySelector('.media-gallery__grid');
    if (!grid) return;

    const frames = Array.from(grid.querySelectorAll(':scope > .product-media-container'))
      .filter((frame) => frame.querySelector('img.product-media__image, img'));
    if (!frames.length) return;

    gallery.dataset.siecleClothingInitialized = 'true';
    const total = frames.length;
    const buttons = [];
    let activeIndex = 0;

    frames.forEach((frame, index) => {
      const image = frame.querySelector('img.product-media__image, img');
      const current = String(index + 1).padStart(2, '0');
      const count = String(total).padStart(2, '0');
      frame.dataset.siecleFrameIndex = current;
      frame.dataset.siecleFrameTotal = count;
      frame.classList.add('siecle-clothing-product-frame');

      if (!frame.querySelector('.siecle-clothing-frame-index')) {
        const label = document.createElement('span');
        label.className = 'siecle-clothing-frame-index';
        label.setAttribute('aria-hidden', 'true');
        label.textContent = `${current} / ${count}`;
        frame.appendChild(label);
      }

      if (image) {
        const alt = image.getAttribute('alt') || `Image ${index + 1} du produit`;
        const src = image.currentSrc || image.getAttribute('src') || image.getAttribute('data-src');
        if (src) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'siecle-clothing-gallery-rail__button';
          button.setAttribute('aria-label', `Afficher l’image ${index + 1} sur ${total} : ${alt}`);
          button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          const thumb = document.createElement('img');
          thumb.src = src;
          thumb.alt = '';
          thumb.loading = index < 3 ? 'eager' : 'lazy';
          button.appendChild(thumb);
          button.addEventListener('click', () => {
            frame.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          });
          buttons.push({ button, frame, index });
        }
      }
    });

    if (buttons.length > 1) {
      const rail = document.createElement('nav');
      rail.className = 'siecle-clothing-gallery-rail';
      rail.setAttribute('aria-label', 'Galerie des images du produit');
      buttons.forEach(({ button }) => rail.appendChild(button));
      const counter = document.createElement('span');
      counter.className = 'siecle-clothing-gallery-rail__count';
      counter.setAttribute('aria-live', 'polite');
      counter.textContent = `01 / ${String(buttons.length).padStart(2, '0')}`;
      rail.appendChild(counter);
      gallery.insertBefore(rail, gallery.firstChild);

      const setActive = (index) => {
        activeIndex = index;
        buttons.forEach(({ button, index: buttonIndex }) => {
          button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
        });
        counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(buttons.length).padStart(2, '0')}`;
        buttons[index]?.button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const candidates = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
          if (!candidates.length) return;
          const activeFrame = candidates[0].target;
          const match = buttons.find(({ frame }) => frame === activeFrame);
          const index = match ? match.index : frames.indexOf(activeFrame);
          if (index >= 0 && index !== activeIndex) setActive(Math.min(index, buttons.length - 1));
        }, { root: null, rootMargin: '-12% 0px -12% 0px', threshold: [0.2, 0.35, 0.5, 0.65, 0.8] });
        frames.forEach((frame) => observer.observe(frame));
      }

      if ('IntersectionObserver' in window) {
        const railVisibility = new IntersectionObserver((entries) => {
          const entry = entries[0];
          rail.classList.toggle('is-visible', Boolean(entry && entry.isIntersecting));
        }, { root: null, rootMargin: '-8% 0px -8% 0px', threshold: 0.01 });
        railVisibility.observe(gallery);
      } else {
        rail.classList.add('is-visible');
      }
    }
  }

  function initializeAll() {
    if (!document.body.matches(bodySelector)) return;
    document.querySelectorAll('.product-information__media media-gallery').forEach(initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:reorder', initializeAll);
})();
